// extracted by mini-css-extract-plugin
export default {"videoPlayerStudio":"VideoPlayerStudio_videoPlayerStudio__VEPDQ","btnPlay":"VideoPlayerStudio_btnPlay__a+oJq"};